import { YearbudgetLimitContainer } from "../../../containers/borrowSystem/Contact/YearbudgetLimitContainer";
export function YearbudgetLimitPage () {
    return(
       <YearbudgetLimitContainer/>
    )
}